import { render, staticRenderFns } from "./VideoNavigation.vue?vue&type=template&id=ddcf6e16&"
import script from "./VideoNavigation.vue?vue&type=script&lang=js&"
export * from "./VideoNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports